import { createHeaders, withReThrowingDataServiceError, } from './data-service-api';
import axios from 'axios';
export class DataServiceDappsApiClient {
    constructor(baseUrl, tokenProvider) {
        this.baseUrl = baseUrl;
        this.tokenProvider = tokenProvider;
    }
    async create(command) {
        const token = await this.tokenProvider.get();
        const fullCommand = {
            ...command,
            publicKey: token.body.sub,
        };
        return withReThrowingDataServiceError(axios
            .post(`${this.baseUrl}/api/v1/dapps`, fullCommand, {
            headers: createHeaders(token),
        })
            .then((it) => it.data));
    }
    async findAllDappAddresses() {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .get(`${this.baseUrl}/api/v1/dapps/${token.body.sub}/dappAddresses`, {
            headers: createHeaders(token),
        })
            .then((it) => it.data));
    }
    async find() {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .get(`${this.baseUrl}/api/v1/dapps/${token.body.sub}`, {
            headers: createHeaders(token),
        })
            .then((it) => it.data));
    }
    async broadcast(command) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .post(`${this.baseUrl}/api/v1/dapps/${token.body.sub}/messages/broadcast`, command, {
            headers: createHeaders(token),
        })
            .then());
    }
    async multicast(command) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .post(`${this.baseUrl}/api/v1/dapps/${token.body.sub}/messages/multicast`, command, {
            headers: createHeaders(token),
        })
            .then());
    }
    async unicast(command) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .post(`${this.baseUrl}/api/v1/dapps/${token.body.sub}/messages/unicast`, command, {
            headers: createHeaders(token),
        })
            .then());
    }
    async findAll(query) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .get(`${this.baseUrl}/api/v1/dapps`, {
            headers: createHeaders(token),
            ...(query && { params: query }),
        })
            .then((it) => it.data));
    }
}
export class DappDto {
}
export class CreateDappCommandDto {
}
export class DappTelegramBotConfigurationDto {
}
export class DappAddressDto {
}
export class AddressDto {
}
export class WalletDto {
}
export var AddressTypeDto;
(function (AddressTypeDto) {
    AddressTypeDto["Email"] = "EMAIL";
    AddressTypeDto["PhoneNumber"] = "PHONE_NUMBER";
    AddressTypeDto["Telegram"] = "TELEGRAM";
    AddressTypeDto["Wallet"] = "WALLET";
})(AddressTypeDto || (AddressTypeDto = {}));
class SendDappMessageCommand {
}
export class UnicastDappMessageCommandDto extends SendDappMessageCommand {
}
export class MulticastDappMessageCommandDto extends SendDappMessageCommand {
}
export class FindDappQueryDto {
}
//# sourceMappingURL=data-service-dapps-api.js.map